import { ThemeEvents } from '@theme/events';

function updateAddToCartLabel(form, quantity) {
  const button = form.querySelector('[ref="addToCartButton"]');
  if (!button || button.disabled) return;

  if (!button.dataset.rpBaseLabel) {
    const textNodes = [...button.childNodes].filter(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );
    if (textNodes[0]) {
      button.dataset.rpBaseLabel = textNodes[0].textContent.trim();
    }
  }

  const baseText = button.dataset.rpBaseLabel;
  if (!baseText) return;

  const label = `${baseText} (${quantity})`;
  const textNodes = [...button.childNodes].filter(
    (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
  );

  if (textNodes[0]) {
    textNodes[0].textContent = ` ${label} `;
    return;
  }

  const added = button.querySelector('.add-to-cart__added');
  const textNode = document.createTextNode(` ${label} `);
  if (added) button.insertBefore(textNode, added);
  else button.appendChild(textNode);
}

function initFabricQuantityForm(form) {
  const input = form.querySelector('quantity-selector-component input[ref="quantityInput"]');
  if (!input) return;

  const sync = (quantity) => {
    const qty = Number.isFinite(quantity) ? quantity : parseInt(input?.value, 10) || 1;
    updateAddToCartLabel(form, qty);
  };

  sync();

  form.addEventListener(ThemeEvents.quantitySelectorUpdate, (event) => {
    if (!(event.target instanceof Element) || !form.contains(event.target)) return;
    sync(event.detail?.quantity);
  });
}

function initAll() {
  for (const form of document.querySelectorAll('product-form-component')) {
    initFabricQuantityForm(form);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);
